import React, { FunctionComponent, useEffect } from 'react';

import Modal from '../Modal/Modal';

import styles from './PopupRefocusModal.scss';
import { useTranslation } from 'react-i18next';
import { useApp } from '../../hooks';

type PopupRefocusModalProps = {
  onClose: () => void;
};

export const PopupRefocusModal: FunctionComponent<PopupRefocusModalProps> = ({
  onClose,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });
  const { popupWindow, hideModal } = useApp();

  useEffect(() => {
    const checkForClosedPopup = setInterval(() => {
      if (!popupWindow || popupWindow.closed) {
        hideModal();
      }
    }, 1000);
    return () => {
      clearTimeout(checkForClosedPopup);
    };
  }, [popupWindow, hideModal]);

  const refocusPopup = (event: React.MouseEvent) => {
    popupWindow?.focus();
    event.stopPropagation();
  };

  return (
    <Modal
      onCloseRequest={onClose}
      className={styles.modal}
      removeScrollbar
      displayCloseButton
      closeOnClickOutsideModal={false}
      onOverlayClick={refocusPopup}
      onModalClick={refocusPopup}
    >
      <p className="jg-h4 jg-space-mbmd">
        {t('popupRefocusModal.lostCheckoutWindow')}
      </p>
      <p className="jg-h4 jg-space-mbn">
        {t('popupRefocusModal.clickAnywhereToRetrieve')}
      </p>
    </Modal>
  );
};
